import styles from './WorkTypes.less';

import React, { Component, PropTypes } from 'react';

import RefineRadio from 'RefineRadio/RefineRadio';
import { ScreenReaderOnly } from 'seek-style-guide/react';
import { preventRenderingInClientIfNot } from 'prevent-rendering-if-not';
import { optimisticUpdateWorkTypeClicked } from 'store/search/optimistic/refinement';

export default class WorkTypes extends Component {

  static propTypes = {
    handleSelection: PropTypes.func.isRequired,
    workTypes: PropTypes.array.isRequired,
    active: PropTypes.bool.isRequired
  };

  shouldComponentUpdate({ active }) {
    return active;
  }

  render() {
    const { handleSelection, workTypes, active } = this.props;

    return (
      <nav role="navigation" className={styles.root}>
        <ScreenReaderOnly>
          <h1 id="RefineWorkType">Work Type</h1>
        </ScreenReaderOnly>
        {preventRenderingInClientIfNot(active) ?
          <RefineRadio
            multiSelect={true}
            handleSelection={handleSelection}
            preNavigationAction={optimisticUpdateWorkTypeClicked}
            labelledBy="RefineWorkType"
            options={workTypes}
            path="/jobs"
            data-automation="refineWorkType"
          /> : null}
      </nav>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/Search/components/RefineBar/components/WorkTypes/WorkTypes.js
 **/